var exports = {
  "i": "x127c5a35--b46f8b--wrapper",
};

module.exports = exports;
